@if (uploadedFiles$ | async; as uploadedFiles) {
    @if (uploadedFiles.length > 0 && isExpanded) {
        <div class="block h-[400px] w-[420px] rounded-[4px] border border-ui-2 bg-base-1 elevation-2">
            <div class="grid grid-cols-2 items-center px-3 py-2 shadow-[0_1px_2px_1px_var(--element-ui-2)]">
                <header class="justify-self-start">
                    <h3 class="m-0 text-[1.2rem] text-text-active-primary">
                        {{ 'upload-popup-header' | translate }}
                    </h3>
                </header>
                <button
                    type="button"
                    class="btn btn-circle btn-sm btn-ghost element-cancel justify-self-end"
                    [attr.aria-label]="'a11y-close' | translate"
                    (click)="isExpanded = false"
                ></button>
            </div>

            <div class="h-[274px] overflow-auto shadow-[inset_0_-4px_2px_-2px_var(--element-ui-2)]">
                @for (file of uploadedFiles; track file.tmp_id; let i = $index) {
                    <div
                        class="grid cursor-pointer grid-cols-[24px_1fr_24px_36px] items-center px-3 py-3 text-[1rem] leading-[1.1rem] text-text-primary select-none"
                        [class.bg-black/10]="file.selected"
                        (click)="setActive(file)"
                        (keydown.enter)="setActive(file)"
                        (keydown.space)="$event.preventDefault(); setActive(file)"
                        tabindex="0"
                        role="button"
                        [attr.aria-label]="'a11y-select-file' | translate: { name: file.name }"
                    >
                        @switch (file.type | fileType) {
                            @case ('image') {
                                <i class="icon element-image text-[#66bb6a]"></i>
                            }
                            @case ('pdf') {
                                <i class="icon element-document-pdf text-[#c62828]"></i>
                            }
                            @case ('video') {
                                <i class="icon element-video text-[#673ab7]"></i>
                            }
                            @default {
                                <i class="icon element-document text-[#90caf9]"></i>
                            }
                        }

                        <div class="overflow-hidden px-[6px] text-ellipsis whitespace-nowrap">
                            {{ file.name }}
                        </div>

                        @switch (file.uploadState) {
                            @case (uploadStates.INITIAL) {
                                <i class="icon element-issue text-status-caution"></i>
                            }
                            @case (uploadStates.EDITED) {
                                <i class="icon element-issue text-status-caution"></i>
                            }
                            @case (uploadStates.READY) {
                                <i class="icon element-ok text-status-success"></i>
                            }
                            @case (uploadStates.UPLOADING) {
                                <i class="icon element-refresh animate-spin text-status-caution"></i>
                            }
                            @case (uploadStates.FINISHED) {
                                <i class="icon element-ok-filled text-status-success"></i>
                            }
                            @case (uploadStates.FAILED) {
                                <i class="icon element-warning text-status-danger"></i>
                            }
                        }

                        <button
                            type="button"
                            class="mx-[6px] cursor-pointer border-0 bg-transparent p-0"
                            [attr.aria-label]="'a11y-remove-file' | translate"
                            (click)="removeFile($event, file)"
                        >
                            <i class="icon element-cancel"></i>
                        </button>
                    </div>

                    @if (file.uploadState === uploadStates.UPLOADING) {
                        <si-progressbar height="small" [value]="undefined"></si-progressbar>
                    }
                    @if (i < uploadedFiles.length - 1) {
                        <hr class="my-0 border-ui-2" />
                    }
                }
            </div>

            <div class="flex w-full flex-row justify-end">
                <button
                    type="button"
                    class="btn btn-primary mt-[10px] mr-3"
                    (click)="uploadFiles()"
                    [disabled]="(readyFiles$ | async)?.length === 0"
                >
                    {{ 'upload-popup-button' | translate }}
                </button>
            </div>
        </div>
    }

    @if (uploadedFiles.length > 0 && !isExpanded) {
        <div>
            <button
                type="button"
                class="btn btn-circle btn-primary element-upload"
                [attr.aria-label]="'a11y-upload' | translate"
                (click)="isExpanded = true"
            >
                <span class="badge-text">{{ uploadedFiles.length }}</span>
            </button>
        </div>
    }
}
